  import React, { useEffect, useState } from "react";
  import { useParams, Link } from "react-router-dom";
  import { fetchCommunityImpact } from "../services/CommunityImpact";
  import { fetchCommunitydetail } from "../services/Communitydetail";
  import { API_BASE } from "../api/apiConfig";

  const CommunityDtlImpact = () => {
    const { id } = useParams();
    const [impactData, setImpactData] = useState(null);
    const [Communitydetaildata, setCommunitydetaildata] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const loadImpact = async () => {
        const result = await fetchCommunityImpact();

        if (result?.status && result?.data?.length > 0) {
          setImpactData(result.data[0]);
        }
      };

      loadImpact();
    }, []);


     useEffect(() => {
      const loadBanner = async () => {
        const res = await fetchCommunitydetail(decodeURIComponent(id));
      
      console.log("API RESPONSE:", res);

        if (res?.data) {
           setCommunitydetaildata(res.data);
        }
        setLoading(false);
      };

      loadBanner();
    }, [id]);


    return (

        <>

          <section className="mb-6 md:mb-10">
            <h2 className="text-lg md:text-2xl font-bold text-slate-800 mb-4">Community Impact</h2>
            
            {/* موبائل ورژن */}
            <div className="md:hidden grid grid-cols-2 gap-3">
              {/* پہلا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-3 text-center">
                <div className="flex justify-center mb-2">
                  <div className="p-2 bg-pink-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-heart h-4 w-4 text-pink-600"
                    >
                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                    </svg>
                  </div>
                </div>
                <p className="text-lg font-bold text-primary">{impactData?.friendships ?? "0"}</p>
                <p className="text-xs font-medium text-slate-800">Lasting Friendships</p>
              </div>
              
              {/* دوسرا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-3 text-center">
                <div className="flex justify-center mb-2">
                  <div className="p-2 bg-blue-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-globe h-4 w-4 text-blue-600"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                      <path d="M2 12h20"></path>
                    </svg>
                  </div>
                </div>
                <p className="text-lg font-bold text-primary">{impactData?.together ?? "0"}</p>
                <p className="text-xs font-medium text-slate-800">Travel Together</p>
              </div>
              
              {/* تیسرا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-3 text-center">
                <div className="flex justify-center mb-2">
                  <div className="p-2 bg-amber-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-award h-4 w-4 text-amber-600"
                    >
                      <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                      <circle cx="12" cy="8" r="6"></circle>
                    </svg>
                  </div>
                </div>
                <p className="text-lg font-bold text-primary">{impactData?.connection ?? "0"}</p>
                <p className="text-xs font-medium text-slate-800">Cultural Connection</p>
              </div>
              
              {/* چوتھا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-3 text-center">
                <div className="flex justify-center mb-2">
                  <div className="p-2 bg-green-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-trending-up h-4 w-4 text-green-600"
                    >
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                      <polyline points="16 7 22 7 22 13"></polyline>
                    </svg>
                  </div>
                </div>
                <p className="text-lg font-bold text-primary">{impactData?.rating ?? "0"}</p>
                <p className="text-xs font-medium text-slate-800">Satisfaction Rating</p>
              </div>
            </div>
            
            {/* ڈیسک ٹاپ ورژن */}
            <div className="hidden md:grid grid-cols-4 gap-4">
              {/* پہلا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 hover:bg-primary/5">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-heart h-5 w-5 text-primary"
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                  </svg>
                </div>
                <p className="text-xl font-bold text-primary">{impactData?.friendships ?? "0"}</p>
                <p className="text-sm font-medium text-slate-800">Lasting Friendships</p>
                <p className="text-xs text-slate-600">Members who've made close friends</p>
              </div>
              
              {/* دوسرا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 hover:bg-primary/5">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-globe h-5 w-5 text-primary"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                    <path d="M2 12h20"></path>
                  </svg>
                </div>
                <p className="text-xl font-bold text-primary">{impactData?.together ?? "0"}</p>
                <p className="text-sm font-medium text-slate-800">Travel Together</p>
              </div>
              
              {/* تیسرا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 hover:bg-primary/5">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-award h-5 w-5 text-primary"
                  >
                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle cx="12" cy="8" r="6"></circle>
                  </svg>
                </div>
                <p className="text-xl font-bold text-primary">{impactData?.connection ?? "0"}</p>
                <p className="text-sm font-medium text-slate-800">Cultural Connection</p>
              </div>
              
              {/* چوتھا کارڈ */}
              <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30 hover:bg-primary/5">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-trending-up h-5 w-5 text-primary"
                  >
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                    <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <p className="text-xl font-bold text-primary">{impactData?.rating ?? "0"}</p>
                <p className="text-sm font-medium text-slate-800">Satisfaction Rating</p>
              </div>
            </div>
          </section>

          <section className="mb-6 md:mb-10">
            {/* मोबाइल व्यू के लिए */}
            <div className="md:hidden bg-white rounded-xl border border-slate-200 p-4">
              <div className="flex items-start gap-3">
                <div
                  className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 flex-shrink-0"
                >
                  <img
                    alt="Rahul M."
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover"
                    style={{ position: 'absolute', height: '100%', width: '100%', inset: 0, color: 'transparent' }}
                    src="/assets/images/testimonial-avatar.png"
                  />
                </div>
                <div className="flex-1">
                  <p className="text-sm italic text-slate-700 mb-2 leading-relaxed">
                    "The Mumbai group feels like family now. We meet weekly and travel together to nearby destinations."
                  </p>
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-medium text-primary">Rahul M.</p>
                    <div className="flex items-center gap-0.5">
                      {/* स्टार आइकन */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 fill-amber-400 text-amber-400"
                      >
                        <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                      </svg>
                      {/* अन्य स्टार आइकन इसी तरह */}
                      {/* ... */}
                      {/* यदि आपको सभी स्टार्स चाहिए तो आप और भी SVG जोड़ सकते हैं। */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* डेस्कटॉप व्यू के लिए */}
            <div className="hidden md:block bg-white rounded-xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
              <div className="flex items-start gap-4">
                <div className="hidden sm:block">
                  <div className="relative h-16 w-16 overflow-hidden rounded-full border-2 border-primary/20">
                    <img
                      alt="Rahul M."
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{ position: 'absolute', height: '100%', width: '100%', inset: 0, color: 'transparent' }}
                      src="/assets/images/testimonial-avatar.png"
                    />
                  </div>
                </div>
                <div>
                  <div className="relative">
                    <div className="absolute -left-2 -top-2 text-3xl text-primary/20">"</div>
                    <p className="pl-5 text-base italic text-slate-700">
                      The Mumbai group feels like family now. We meet weekly and travel together to nearby destinations.
                    </p>
                    <div className="absolute -bottom-1 right-0 text-3xl text-primary/20">"</div>
                  </div>
                  <p className="mt-3 text-sm font-medium text-primary">Rahul M.</p>
                </div>
              </div>
            </div>
          </section>




    <section className="mb-6 md:mb-10">
      {/* Mobile view */}
      <div className="md:hidden bg-gradient-to-br from-primary/10 to-purple-500/10 rounded-xl border border-primary/20 overflow-hidden">
        <div className="p-4 text-center">
          <div className="mb-4">
            <div className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary mb-3">
              <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary animate-pulse"></span>
              Exclusive Community
            </div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">Join the Travel Community</h2>
            <p className="text-sm text-slate-600 mb-4">
              Connect with 1240+ travelers and explore Mumbai like never before
            </p>
          </div>
          <div className="space-y-3 mb-4">
            <div className="flex items-center gap-3 text-slate-700">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-users h-3 w-3"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <span className="text-sm text-left">Connect with 1240+ local travelers</span>
            </div>
            <div className="flex items-center gap-3 text-slate-700">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar h-3 w-3"
                >
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect width="18" height="18" x="3" y="4" rx="2" />
                  <path d="M3 10h18" />
                </svg>
              </div>
              <span className="text-sm text-left">4 monthly exclusive meetups</span>
            </div>
            <div className="flex items-center gap-3 text-slate-700">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-3 w-3"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <span className="text-sm text-left">Explore hidden gems with local experts</span>
            </div>
            <div className="flex items-center gap-3 text-slate-700">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-heart h-3 w-3"
                >
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                </svg>
              </div>
              <span className="text-sm text-left">Build lasting friendships</span>
            </div>
          </div>
          <div className="space-y-2">
            <a href={`/CommunityJoin/${Communitydetaildata?.id}`}>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 text-sm h-9">
                Join Now for ₹99
              </button>
            </a>
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10 text-sm h-9 bg-transparent">
              Learn More
            </button>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-2">
            <div className="rounded-lg bg-white/80 p-2">
              <p className="text-sm font-bold text-primary">{impactData?.member ?? "0"}</p>
              <p className="text-xs text-slate-600">Members</p>
            </div>
            <div className="rounded-lg bg-white/80 p-2">
              <p className="text-sm font-bold text-primary">{impactData?.cities ?? "0"}</p>
              <p className="text-xs text-slate-600">Cities</p>
            </div>
            <div className="rounded-lg bg-white/80 p-2">
              <p className="text-sm font-bold text-primary">{impactData?.meetups ?? "0"}</p>
              <p className="text-xs text-slate-600">Meetups</p>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop view */}
      <div className="hidden md:block rounded-xl overflow-hidden border border-primary/30 shadow-lg">
        <div className="relative">
          <div className="absolute inset-0 bg-[url('/diagonal-pattern.png')] opacity-5" style={{ position: "relative", zIndex: 9999 }}></div>
          <div className="grid grid-cols-2">
            <div className="relative h-full overflow-hidden">
              <img
                alt="Join our community"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0,
                  color: "transparent",
                }}
                src="/placeholder.svg?key=qnt2v"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary/70 via-primary/40 to-primary/20"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center px-4 py-3 rounded-lg bg-black/20 backdrop-blur-sm">
                  <h3 className="text-xl sm:text-2xl font-bold text-white shadow-[0_2px_4px_rgba(0,0,0,0.8)] [text-shadow:_0_2px_4px_rgba(0,0,0,0.8)]">
                    Explore Mumbai Together
                  </h3>
                  <p className="text-sm sm:text-base text-white/90 mt-2 max-w-xs mx-auto shadow-[0_1px_3px_rgba(0,0,0,0.7)] [text-shadow:_0_1px_3px_rgba(0,0,0,0.7)]">
                    Join our community of passionate travelers
                  </p>
                </div>
              </div>
              <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm p-3 rounded-lg shadow-md border border-white/50">
                <div className="flex items-center gap-3">
                  <div className="relative h-10 w-10 sm:h-12 sm:w-12 rounded-full overflow-hidden border-2 border-primary/30 flex-shrink-0">
                    <img
                      alt="Community member"
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent",
                      }}
                      src="/assets/images/testimonial-avatar.png"
                    />
                  </div>
                  <div>
                    <p className="text-xs sm:text-sm italic text-slate-700">
                      "This community changed how I explore India!"
                    </p>
                    <p className="text-xs font-medium text-primary">Priya S., Member since 2022</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-white to-primary/5 p-5 sm:p-6 md:p-8">
              <div className="mb-2 inline-flex items-center rounded-full bg-primary/10 px-2 py-1 text-xs sm:text-sm font-medium text-primary">
                <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary animate-pulse"></span>
                Exclusive Community
              </div>
              <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-slate-800 mb-2 sm:mb-3">
                Join the Travel Community
              </h2>
              <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-5">
                <div className="flex items-center gap-2 text-slate-700">
                  <div className="flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-3 w-3 sm:h-4 sm:w-4"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                  </div>
                  <span className="text-xs sm:text-sm text-left">Connect with 1240+ local travelers</span>
                </div>
                <div className="flex items-center gap-2 text-slate-700">
                  <div className="flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-3 w-3 sm:h-4 sm:w-4"
                    >
                      <path d="M8 2v4" />
                      <path d="M16 2v4" />
                      <rect width="18" height="18" x="3" y="4" rx="2" />
                      <path d="M3 10h18" />
                    </svg>
                  </div>
                  <span className="text-xs sm:text-sm text-left">Access to 4 monthly exclusive meetups</span>
                </div>
                <div className="flex items-center gap-2 text-slate-700">
                  <div className="flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-3 w-3 sm:h-4 sm:w-4"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>
                  <span className="text-xs sm:text-sm text-left">Explore hidden gems with local experts</span>
                </div>
                <div className="flex items-center gap-2 text-slate-700">
                  <div className="flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-heart h-3 w-3 sm:h-4 sm:w-4"
                    >
                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                    </svg>
                  </div>
                  <span className="text-xs sm:text-sm text-left">Build lasting friendships with fellow travelers</span>
                </div>
              </div>
              <div className="space-y-2 sm:space-y-3">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                  <a href={`/CommunityJoin/${Communitydetaildata?.id}`}>
                    <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 py-2 w-full sm:w-auto bg-primary text-white hover:bg-primary/90 text-sm h-9 px-4 sm:px-6">
                      Join Now for ₹99
                    </button>
                  </a>
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground py-2 w-full sm:w-auto border-primary/30 text-primary hover:bg-primary/10 text-sm h-9 px-4 sm:px-6 bg-transparent">
                    Learn More
                  </button>
                </div>
              </div>
              <div className="mt-4 sm:mt-6 grid grid-cols-3 gap-2 sm:gap-3">
                <div className="rounded-lg bg-white/80 p-2 sm:p-3 text-center">
                  <p className="text-sm sm:text-base font-bold text-primary">{impactData?.member ?? "0"}</p>
                  <p className="text-xs sm:text-sm text-slate-600">Members</p>
                </div>
                <div className="rounded-lg bg-white/80 p-2 sm:p-3 text-center">
                  <p className="text-sm sm:text-base font-bold text-primary">{impactData?.cities ?? "0"}</p>
                  <p className="text-xs sm:text-sm text-slate-600">Cities</p>
                </div>
                <div className="rounded-lg bg-white/80 p-2 sm:p-3 text-center">
                  <p className="text-sm sm:text-base font-bold text-primary">{impactData?.meetups ?? "0"}</p>
                  <p className="text-xs sm:text-sm text-slate-600">Meetups</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
   
   </>

    );
  };

  export default CommunityDtlImpact;
